module.exports = __webpack_public_path__ + "static/media/memsql.a370bd71.svg";